<mat-chip [disabled]="disabled" class="text-white text-uppercase font-weight-bold" [matTooltip]="iconOnly ? itemTypeName : null"
  matTooltipPosition="above" disableRipple [ngClass]="itemTypeClass + ' ' + chipClasses">
  <mat-icon [svgIcon]="itemTypeIcon" [class.mr-2]="!iconOnly"></mat-icon>
  <span *ngIf="!iconOnly">{{itemTypeName}}</span>
</mat-chip>